import { v4 as uuidv4 } from 'uuid';
import { getCurrentDateTime } from './dates';
import Cookie from 'js-cookie';

export const typedAction = (type, payload = {}) => ({ type, payload });

export const headers = {
  'dateTime': getCurrentDateTime(),
  'traceId': uuidv4(),
  'x-api-key': process.env.REACT_APP_X_API_KEY
};

export const handlerRequestErrors = (error, username = null) => {
  switch (error.code) {
    case 'UserNotConfirmedException':
      return {
        ...error,
        message: 'Tu usuario se encuentra bloqueado'
      };
    case 'PasswordResetRequiredException':
      return {
        ...error,
        message: 'Tu usuario requiere reseteo de contraseña'
      };
    case 'NotAuthorizedException':
      const userWithError = Cookie.get(username);
      const userWithErrorAsJson = userWithError ? JSON.parse(userWithError) : {};
      const failedAttempts = userWithError ? userWithErrorAsJson.failedAttempts + 1 : 1;
      const expiresInOneMinute = new Date(new Date().getTime() + 60 * 1000);
      Cookie.set(username, JSON.stringify({ username, failedAttempts }), { expires: expiresInOneMinute });

      return {
        ...error,
        message: 'Valida que tu usuario o contraseña sean correctos'
      };
    case 'UserNotFoundException':
      return {
        ...error,
        message: 'El usuario ingresado no existe'
      };
    default:
      const {
        response: {
          data: {
            response: {
              status: { error: { messages: [message] = [] } = {} } = {}
            } = {}
          } = {}
        } = {}
      } = error;

      return {
        ...error,
        message: message || 'Hemos tenido un inconveniente. Intenta nuevamente'
      };
  }
};

const rutaBase = '/seguimiento';

const rutasGenericas = [
  rutaBase,
  rutaBase + '/creacion/quick',
  rutaBase + '/creacion/deep',
  rutaBase + '/listado/quick',
  rutaBase + '/listado/deep',
  rutaBase + '/detalle/deep',
  rutaBase + '/cierre/deep'
];

export const federatedRol = [
  {
    id: '6c35ef04-ff86-46b4-a933-202df44e58d4',
    rol: 'G_USR_POWERRIMAC_ASESOR',
    path: [rutaBase, rutaBase + '/detalle/deep']
  },
  {
    id: '895cdb6c-b7cc-4175-8382-55edb61e256f',
    rol: 'G_USR_POWERRIMAC_SUPER',
    path: rutasGenericas
  },
  {
    id: '1fd6878c-254e-46ef-83cd-beab0cb89054',
    rol: 'G_USR_POWERRIMAC_JEFE',
    path: rutasGenericas
  }
];

export const federatedCanal = [
  {
    id: '910cf935-29ab-4b46-9edd-5599a08f631a',
    canal: 'G_CANAL_POWERRIMAC_BSA',
    name: 'BSA'
  },
  {
    id: '1257fffb-844a-48eb-85af-0187d60890c2',
    canal: 'G_CANAL_POWERRIMAC_RENTAS',
    name: 'RENTAS'
  },
  {
    id: '5016fa24-24bd-431f-80c8-3ff6a7e220be',
    canal: 'G_CANAL_POWERRIMAC_TLMK',
    name: 'TELEMARKETING'
  }
];

/**
 * @param {Array} data
 * @return {String} 'rol'
 *
 */
export const getRolById = (data = []) => federatedRol.find(({ id, rol }) => data.includes(process.env.REACT_APP_CUSTON_ENV === 'dev' ? id : rol)).rol;

/**
 * @param {Array} data
 * @return {String} 'canal'
 *
 */
export const getCanalById = (data = []) => federatedCanal.find(({ id, canal }) => data.includes(process.env.REACT_APP_CUSTON_ENV === 'dev' ? id : canal)).name;

/**
 * @param {String} name 'Federation_name'
 * @return {String} 'name'
 */
export const removeFederationName = (name = '') => {
  return name.replace(
    new RegExp(`${process.env.REACT_APP_OAUTH_PROVIDER}_`, 'g'),
    ''
  );
};

/**
 * @param {string} currentRole
 * @param {string[{}]} rolesTypes
 * @return {string} Devuelve un Rol literal
 * @example
 * getCurrentLiteralRoleType(..., [...])
 *  return 'JEFE' | 'SUPERVISOR' | 'ASESOR'
 */
export const getCurrentLiteralRoleType = (currentRole, rolesTypes) => {
  if (rolesTypes.jefe === currentRole) {
    return 'JEFE';
  }
  if (rolesTypes.supervisor === currentRole) {
    return 'SUPERVISOR';
  }
  return 'ASESOR';
};

export const inicioRoute = () => '/seguimiento';
